module.exports = __webpack_public_path__ + "static/media/delete.9caa158c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/delete.svg
// module id = 33
// module chunks = 0